import { render, staticRenderFns } from "./import-visit-follow-case.vue?vue&type=template&id=57554e2e&scoped=true"
import script from "./import-visit-follow-case.vue?vue&type=script&lang=ts"
export * from "./import-visit-follow-case.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57554e2e",
  null
  
)

export default component.exports